<template>
	<div :class="loading ? 'loading' : ''" class="widget">
		<LoadingWrapper :loading="loading" hide-placeholder show-content>
			<div class="widget-grid">
				<h3>{{ title }}</h3>

				<dl>
					<dt>{{ label }}</dt>
					<dd>{{ loading ? '-' : value }}</dd>
				</dl>

				<div class="cta">
					<BaseButton
							v-if="cta"
							:btn-class="cta.btnClass"
							:text="cta.text"
							:to="cta.to"
					/>
				</div>

				<div v-if="typeof $slots.default !== 'undefined'" class="buttons-slot">
					<slot></slot>
				</div>
			</div>
		</LoadingWrapper>
	</div>
</template>
<script lang="ts" setup>
	import type {PropType} from 'vue';
	import type {RouteLocationRaw} from 'vue-router';
	import LoadingWrapper from '~/components/generic/LoadingWrapper.vue';
	import BaseButton from '~/components/generic/buttons/BaseButton.vue';
	import type {ButtonClass} from '~/lib/types/ButtonTypes';

	defineProps({
		loading: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		value: {
			type: [String, Number],
			required: true
		},
		cta: {
			type: Object as PropType<{
				text: string,
				to: RouteLocationRaw,
				btnClass: ButtonClass
			}>,
			default: undefined
		}
	});
</script>

<style scoped>
	.widget {
		background: #ffffff;
		border-radius: 5px;
	}

	.widget-grid {
		padding: 10px;
		display: grid;
		grid-template-areas: "title title" "summary cta";
	}

	h3 {
		font-weight: normal;
		font-size: var(--font-size-p-2);
		line-height: var(--line-height-p-2);
		grid-area: title;
	}

	dl {
		grid-area: summary;
		padding: 8px;
		margin: 0;
	}

	dt {
		font-size: var(--font-size-p-1);
		color: var(--color-grey-300);
		font-weight: normal;
		line-height: var(--line-height-p-1);
	}

	dd {
		font-size: var(--font-size-p-4);
		line-height: var(--line-height-p-4);
		font-weight: bold;
	}

	.cta {
		grid-area: cta;
		display: grid;
		align-items: start;
		justify-items: end;
		padding: 8px;
	}

	.loading {
		dd {
			opacity: .2;
		}
	}

	.buttons-slot {
		margin-top: 8px;
		grid-column-start: 1;
		grid-column-end: -1;
		max-width: 100%;
	}

</style>
